// HighlightsCarousel.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../assets/css/HighlightsCarousel.css';

const HighlightsCarousel = () => {
  const [articles, setArticles] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    axios
      .get('https://my-strapi-cms-5r1k.onrender.com/api/news-articles?populate=*')
      .then((res) => setArticles(res.data.data))
      .catch((err) => console.error(err));
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % Math.ceil(articles.length / 3));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + Math.ceil(articles.length / 3)) % Math.ceil(articles.length / 3));
  };

  const getVisibleArticles = () => {
    const startIndex = currentSlide * 3;
    return articles.slice(startIndex, startIndex + 3);
  };

  return (
    <div className="carousel-container">
      <div className="carousel-wrapper">
        <button onClick={prevSlide} className="carousel-button">‹</button>
        <div className="carousel-slide">
          {getVisibleArticles().map((item) => (
            <div key={item.id} className="carousel-tile">
              <img
                src={`https://my-strapi-cms-5r1k.onrender.com${item.Image[0].url || ''}`}
                alt={item.Title}
                className="carousel-image"
              />
              <div className="carousel-date">
                {new Date(item.PublishedDateTime).toLocaleDateString()}
              </div>
              <h3 className="carousel-heading">{item.Title}</h3>
              <a href={`/highlights-insights/${item.id}`} className="carousel-readmore">Read More</a>
            </div>
          ))}
        </div>
        <button onClick={nextSlide} className="carousel-button">›</button>
      </div>
    </div>
  );
};

export default HighlightsCarousel;